import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  video: '.js-xray__video-video',
  foreground: '.js-xray__foreground',
  marquee: '.js-marquee'
}

class MinecraftKosovo {
  constructor(element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.video = this.element.querySelector(SELECTORS.video)
    this.foreground = this.element.querySelector(SELECTORS.foreground)
    this.marquee = this.element.querySelector(SELECTORS.marquee)

    this.init()
  }

  init() {
    this.foreground.classList.add('-hide')

    /* Register event listeners: */
    this.registerEvents()

    /* TODO: Update to skip the intro and land directly on the x-ray state */
    if (document.documentElement.classList.contains('reduced-motion')) {
      this.videoStarted()
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: '-25% top',
        end: 'bottom',
        scrub: 1,
        once: true,
        onEnter: () => this.video.play()
      }
    })

    ScrollTrigger.refresh()
  }

  registerEvents() {
    this.video.addEventListener('play', () => this.videoStarted())
    this.video.addEventListener('ended', () => this.videoEnded())

    if (this.video.readyState >= 2) {
      this.element.classList.remove('-preload')
    } else {
      this.video.addEventListener('canplay', () => {
        this.element.classList.remove('-preload')
      })
    }
  }

  videoStarted() {
    this.element.classList.add('-intro')
  }

  videoEnded() {
    this.foreground.classList.remove('-hide')
    this.marquee.classList.remove('-animate')
  }
}

export default {
  selector: '.js-minecraft-kosovo',
  Source: MinecraftKosovo
}
